let LinkBehaviour = /* @__PURE__ */ function(LinkBehaviour2) {
  LinkBehaviour2["NewWindow"] = "NEW_WINDOW";
  LinkBehaviour2["Standard"] = "STANDARD";
  return LinkBehaviour2;
}({});

export { LinkBehaviour };
//# sourceMappingURL=shared.js.map
